// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const PaintRoller_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.75 8.25h-1.5V6a1.5 1.5 0 0 0-1.5-1.5H4.5A1.5 1.5 0 0 0 3 6v2.25H1.5a.75.75 0 0 0 0 1.5H3V12a1.5 1.5 0 0 0 1.5 1.5h14.25a1.5 1.5 0 0 0 1.5-1.5V9.75h1.5v4.688l-9.413 2.685a1.51 1.51 0 0 0-1.087 1.44v3.187a.75.75 0 0 0 1.5 0v-3.187l9.413-2.69a1.51 1.51 0 0 0 1.087-1.435V9.75a1.5 1.5 0 0 0-1.5-1.5Zm-3 3.75H4.5V6h14.25v6Z',
  viewBox: '0 0 24 24',
  glyph: 'PaintRoller_Stroke2_Corner2_Rounded',
})
